const styles = theme => ({
  container: {
    width: '100%',
  },
  premiseContainer: {
    width: '100%',
    marginTop: '6px',
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-start',
    gap: '16px',
  },
  premiseFieldContainer: {
    flex: 1,
  },
  fetchDetailsBtn: {
    minWidth: '185px',
    background: theme.palette.primary.adgmBlack,
    color: theme.palette.primary.white,
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '24px',
    textTransform: 'capitalize',
    padding: '16px',
    borderRadius: '4px',
    '&:hover': {
      background: theme.palette.primary.adgmBlack,
      color: theme.palette.primary.white,
    },
    '&:focus': {
      background: theme.palette.primary.adgmBlack,
      color: theme.palette.primary.white,
    },
  },
  hint: {
    marginTop: '6px',
    color: theme.palette.primary.metal,
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '18px',
  },
  divider: {
    margin: '20px 0',
    borderTop: `1px solid ${theme.palette.primary.borderColor}`,
  },
  premiseAddressContainer: {},
  premiseAddressLabel: {
    color: theme.palette.secondary.dim,
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '21px',
  },
  premiseAddress: {
    color: theme.palette.primary.adgmBlack,
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '24px',
  },
});

export default styles;
